import { render, staticRenderFns } from "./ModalVerificationTransfer.vue?vue&type=template&id=a7096c6a"
import script from "./ModalVerificationTransfer.vue?vue&type=script&lang=js"
export * from "./ModalVerificationTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Development/QC/qcheck-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports